<script setup lang="ts">
  import { addMonths, subMonths } from 'date-fns'
  import { onMounted, watch } from 'vue'
  import { useRoute } from 'vue-router'
  import { fmt, useUpdateRoute } from '@/functions'

  const { updateRoute } = useUpdateRoute()
  const route = useRoute()

  const month = defineModel<number>('month', { default: 1 })
  const year = defineModel<number>('year', { default: 2026 })
  onMounted(() => {
    month.value = route.query.month ? Number(route.query.month) : new Date().getMonth() + 1
    year.value = Number(route.query.year ?? new Date().getFullYear())
  })

  watch([month, year], ([newMonth, newYear]) => {
    updateRoute({
      month: newMonth,
      year: newYear,
    })
  })

  const goToPreviousMonth = () => {
    const date = subMonths(new Date(year.value, month.value - 1), 1)
    month.value = date.getMonth() + 1
    year.value = date.getFullYear()
  }
  const goToNextMonth = () => {
    const date = addMonths(new Date(year.value, month.value - 1), 1)
    month.value = date.getMonth() + 1
    year.value = date.getFullYear()
  }
</script>

<template>
  <div>
    <div class="flex items-center border rounded h-[var(--h-input)]">
      <app-button
        class="px-1 w-8 border-r h-full pt-1 text-gray-400"
        @click="goToPreviousMonth">
        <fa-icon icon="i-far-angle-left" />
      </app-button>
      <div class="text-center text-sm w-20 flex items-center justify-center">
        {{ fmt.date(new Date(year, month - 1), 'MMM yyyy') }}
      </div>
      <app-button
        class="px-1 w-8 border-l h-full pt-1 text-gray-400"
        @click="goToNextMonth">
        <fa-icon icon="i-far-angle-right" />
      </app-button>
    </div>
  </div>
</template>
